import { render } from "./CurrencyInput.vue?vue&type=template&id=e9bb4ae6"
import script from "./CurrencyInput.vue?vue&type=script&lang=js"
export * from "./CurrencyInput.vue?vue&type=script&lang=js"
script.render = render

export default script